import { forwardRef } from 'react';

import { TextFieldProps } from './text-field-interfaces';
import { TextFieldStyled } from './text-field-styles';

const TextField = forwardRef((props: TextFieldProps, ref) => {
  let fullWidth = true;

  // eslint-disable-next-line react/prop-types
  if (props.fullWidth != null) {
    // eslint-disable-next-line react/prop-types
    fullWidth = props.fullWidth;
  }

  const template: JSX.Element = <TextFieldStyled {...props} ref={ref} fullWidth={fullWidth} />;

  return template;
});

export default TextField;
